import React from "react";

import styles from "./styles.css";

export const DropdownCaret = ({ isExpanded, onClick }) =>
	(
		<>
			{isExpanded && (
				<div className={styles.expandIcon} onClick={onClick}>
					<i className="fa fa-caret-down" aria-hidden="true" />
				</div>
			)}
			{!isExpanded && (
				<div className={styles.expandIcon} onClick={onClick}>
					<i className="fa fa-caret-right" aria-hidden="true" />
				</div>
			)}
		</>
	);
